import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandResponse } from 'app/models/BrandResponse';
import { UnitDto } from 'app/models/unit-dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2" ;
  }
  constructor(private http:HttpClient) { }

  getUnits(page: number = 0, storeId: number = 1, userId: number = 1, languageCode: string = 'en'): Observable<BrandResponse> {
        return this.http.get<BrandResponse>(`${this.apiUrl}/units?page=${page}`);
      }
  getUnitById(id: number = 0): Observable<UnitDto> {
  return this.http.get<UnitDto>(`${this.apiUrl}/units/${id}`);
}
   // Create a new unit
  createUnit(unit : UnitDto): Observable<UnitDto> {
   
    return this.http.post<UnitDto>(this.apiUrl+"/units", unit);
  }

  // Update an existing unit
  updateUnit(id: number,unit : UnitDto ): Observable<UnitDto> {
    
    return this.http.put<UnitDto>(`${this.apiUrl}/units/${id}`, unit);
  }

  // Delete a unit
  deleteUnit(id: number): Observable<BrandResponse> {
    return this.http.delete<BrandResponse>(`${this.apiUrl}/units/${id}`);
  }
}

